<template>
  <div class="payment-status-container">
    <h1 class="success-title">Zahlung erfolgreich 🎉</h1>
    <p>Ihre Zahlung wurde von PayPal genehmigt.</p>
    <p>Sie werden in {{ countdown }} Sekunden zur Startseite weitergeleitet...</p>

    <router-link to="/" class="home-link">Zurück zur Startseite</router-link>
  </div>
</template>

<script lang="ts">
import { Vue, Component } from 'vue-property-decorator'

@Component({})
export default class PaymentSuccess extends Vue {
  private countdown = 5

  mounted () {
    // Step A: read the PayPal token from URL (optional but recommended)
    const token = this.$route.query.token
    console.log('PayPal success token:', token)

    // Step B: call backend to capture payment
    if (typeof token === 'string') {
      this.capturePayment(token)
    } else {
      console.error('Failed to capture token:', this.$route.fullPath)
    }

    // Step C: schedule redirect
    this.startCountdown()
  }

  startCountdown () {
    const interval = setInterval(() => {
      this.countdown--
      if (this.countdown <= 0) {
        clearInterval(interval)
        this.$router.push('/')
      }
    }, 1000)
  }

  async capturePayment (token:string) {
    if (!token) return
    if (token.length <= 0) return

    try {
      const res = await Vue.axios.get('/paypal/capture?token=' + token)

      console.log('Payment captured on backend.')
    } catch (error) {
      console.error('Failed to capture payment:', error)
    }
  }
}
</script>

<style scoped>
.payment-status-container {
  max-width: 600px;
  margin: 80px auto;
  text-align: center;
}

.success-title {
  color: #0b9e43;
}

.home-link {
  display: block;
  margin-top: 20px;
  color: #007bff;
}
</style>
